// ANSI color helpers for build/server logs.
// In the browser these are no-ops — raw escape codes would be garbage in DevTools.
// CloudWatch strips ANSI automatically, so server-side logs stay readable there too.
// Enable colors in any Node.js environment (terminal, CI, CloudWatch).
// Only disable in the browser where ANSI codes show as garbage in DevTools.
// CloudWatch and CI pipelines strip or ignore ANSI sequences automatically.
const isNode = typeof process !== "undefined" && !!process.versions?.node;

const wrap = (code) => isNode ? (s) => `\x1b[${code}m${s}\x1b[0m` : (s) => s;

const color = {
  red: wrap(31),
  yellow: wrap(33),
  green: wrap(32),
  cyan: wrap(36),
};

module.exports = { color };
